module.exports = __webpack_public_path__ + "img/cgal-02.f7ea5202.jpg";